app.controller("EmployeeShareDocumentController", [
    "$scope", "$uibModalInstance", "Position", "params", "DocumentsService", "OrganizationalUnit", "usSpinnerService", "toastr",
    function ($scope, $uibModalInstance, Position, params, DocumentsService, OrganizationalUnit, usSpinnerService, toastr) {
        $scope.addressees = [];
        $scope.unit = null;
        $scope.employee = null;
        $scope.documentId = params.documentId;

        $scope.getEmployees = function (query) {
            if (query.length < 2) {
                return [];
            }
            $scope.selected = false;
            return DocumentsService.staffList({query: query}).then(function (data) {
                return data.docs.filter(function (usr) {
                    var el_index = _.findIndex($scope.users, function (user) {
                        return user._id === usr._id;
                    });
                    return el_index === -1;
                })
            });
        };

        $scope.getUnits = function (query) {
            if (query.length < 2) {
                return [];
            }
            return OrganizationalUnit.findByQuery({query: query}).then(function (data) {
                return data;
            });
        };

        $scope.$watch('employee', function (val) {
            if (val && val._id) {
                $scope.addToAddresseeList(val)
            }
        }, true);

        $scope.$watch('unit', function (val) {
            if (val && val._id) {
                $scope.addToAddresseeList(val)
            }
        }, true);

        $scope.addToAddresseeList = function (addressee) {
            if (addressee) {
                var index = _.findIndex($scope.addressees, function (addr) {
                    return addressee._id === addr._id;
                });

                if (index > -1) {
                    toastr.error('', 'ადრესატი უკვე დამატებულია');
                } else {
                    if(addressee.user) addressee.isUnit = false;
                    if(!addressee.user) addressee.isUnit = true;
                    $scope.addressees.push(addressee);
                }
                $scope.employee = null;
                $scope.unit = null;
            }
        };

        $scope.deleteAddressee = function (id) {
            var el_index = _.findIndex($scope.addressees, function (addr) {
                return id === addr._id;
            });

            $scope.addressees.splice(el_index, 1);
        };

        $scope.share = function () {
            const reqData = {
                documentId: $scope.documentId,
                comment: $scope.comment,
                addressees: $scope.addressees
            };

            DocumentsService.shareDocument(reqData).then(function (res) {
                toastr.success('დოკუმენტი გაზიარებულია');
                $uibModalInstance.close();
            }).catch(function (err) {
                toastr.error('', 'დაფიქსირდა შეცდომა');
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
